import './form-option-list.scss';

import { components } from 'gridstrap/lib/gs-components';
import { GSFormOptionList } from './form-option-list';

components.register({
	selector: '.gs-FormOptionList',
	controller: GSFormOptionList
});
